import React from 'react'
import { InsightCallout, InsightsList, SectionCard, SectionTitle } from '../styles'

const InsightsPanel = ({ insights = [], title = 'Observações' }) => {
    if (!insights?.length) return null

    return (
        <SectionCard>
            <SectionTitle>{title}</SectionTitle>
            <InsightsList>
                {insights.map((insight, index) => (
                    <li key={`${insight}-${index}`}>
                        <InsightCallout>{insight}</InsightCallout>
                    </li>
                ))}
            </InsightsList>
        </SectionCard>
    )
}

export default InsightsPanel
